import checkIsVariantEnabled from './checkIsVariantEnabled';
import checkIsVariantVisible from './checkIsVariantVisible';

export default function checkHasVisibleVariants(
  productVariants = [],
  formVariants = {},
  query = {},
  isPreview,
) {
  const hasEnabledOrVisibleVariant = productVariants.some(variant => {
    const isVariantEnabled = checkIsVariantEnabled(variant, formVariants, productVariants);
    const isVariantVisible = checkIsVariantVisible(variant, query);

    return isVariantEnabled && isVariantVisible;
  });

  if (hasEnabledOrVisibleVariant) {
    return true;
  } else if (productVariants.length > 0 && isPreview) {
    return true;
  }

  return false;
}
